import React, { useState, useEffect } from 'react';
import { Tag, Input } from 'antd';
import { updateOrganization } from '../organization';
import styles from './index.module.css';

type Props = {
  orgId: number;
  tagsDefault: string[];
  shouldSave: boolean;
  setShouldSave: (shouldSave: boolean) => void;
};

export const TagsDefault: React.FC<Props> = ({
  orgId,
  tagsDefault,
  shouldSave,
  setShouldSave
}) => {
  const [tags, setTags] = useState<string[]>(
    Array.isArray(tagsDefault) ? tagsDefault : []
  );
  const [inputValue, setInputValue] = useState('');
  const [inputVisible, setInputVisible] = useState(false);

  const handleClose = (removedTag: string) => {
    const newTags = tags.filter(tag => tag !== removedTag);
    setTags(newTags);
  };

  const showInput = () => setInputVisible(true);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleInputConfirm = () => {
    if (inputValue && !tags.includes(inputValue)) {
      setTags([...tags, inputValue]);
    }
    setInputVisible(false);
    setInputValue('');
  };

  useEffect(() => {
    if (shouldSave) {
      updateOrganization({
        organizationId: orgId,
        body: { tagsDefault: JSON.stringify(tags) },
        showSuccess: false
      });
    }
    setShouldSave(false);
  }, [shouldSave]);

  return (
    <div>
      <h3>Default Tags</h3>
      <div className={styles.tagsContainer}>
        {tags.map(tag => (
          <Tag key={tag} closable onClose={() => handleClose(tag)}>
            {tag}
          </Tag>
        ))}
        {inputVisible ? (
          <Input
            type="text"
            size="small"
            style={{ width: 120 }}
            value={inputValue}
            onChange={handleInputChange}
            onBlur={handleInputConfirm}
            onPressEnter={handleInputConfirm}
            autoFocus
          />
        ) : (
          <Tag onClick={showInput} className={styles.newTag}>
            + New Tag
          </Tag>
        )}
      </div>
    </div>
  );
};
